
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M384.977 276.115c-.33-.902-33.149-90.694-47.603-132.749-9.325-27.136-24.962-40.895-46.474-40.895h-69.8c-21.512 0-37.149 13.759-46.474 40.895-14.452 42.055-47.272 131.848-47.603 132.749-3.812 10.425 1.549 21.968 11.975 25.779 10.425 3.812 21.968-1.551 25.779-11.975.273-.748 22.776-62.314 38.824-107.645 1.435 4.712 4.37 8.758 8.233 11.627l.048 29.451-34.573 87.18c-1.885 4.755.875 10.067 5.834 11.259 5.161 1.24 11.996 2.93 19.41 4.782V487.88c0 13.321 10.799 24.12 24.12 24.12 13.321 0 24.12-10.799 24.12-24.12V337.975a58.6 58.6 0 0010.413-.006V487.88c0 13.321 10.799 24.12 24.12 24.12 13.321 0 24.12-10.799 24.12-24.12V326.551a2219.507 2219.507 0 0119.398-4.776c4.924-1.18 7.731-6.492 5.84-11.261l-34.567-87.163.048-29.451c3.864-2.868 6.797-6.914 8.233-11.627 16.047 45.331 38.551 106.897 38.824 107.645 3.812 10.426 15.354 15.787 25.779 11.975 10.427-3.81 15.788-15.353 11.976-25.778z","fill":"#455aa9"}}),_c('circle',{attrs:{"cx":"256","cy":"43.898","r":"43.898","fill":"#455aa9"}})])
          )
        }
      }
    